import Swiper from 'swiper';
import { Controller, Navigation, EffectFade } from 'swiper/modules';

export default () => ({
  swiper: null,

  async init() {
    const swiper = new Swiper(this.$refs.slider, {
      slidesPerView: 1,
      modules: [Controller, Navigation, EffectFade],
      spaceBetween: 40,
      loop: true,
      loopAdditionalSlides: 1,
      effect: this.$refs.thumbSlider ? 'slide' : 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        prevEl: this.$refs.prev,
        nextEl: this.$refs.next
      }
    });

    if (this.$refs.thumbSlider) {
      const thumbSwiper = new Swiper(this.$refs.thumbSlider, {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        loopAdditionalSlides: 1,
        modules: [Controller],
        navigation: {
          enabled: false
        }
      });

      thumbSwiper.controller.control = swiper;
      swiper.controller.control = thumbSwiper;
    }
  }
});
